<div *ngIf="emptyData" class="subtitle" fxLayout="row" fxLayoutAlign="space-around center">
  {{ 'MISSING_DATA' | translate }}
</div>
<div id="{{container}}"></div>
